var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar-date",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_163_10",
    "data-name": "Component 163 \\u2013 10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "calendar-date-2",
    "data-name": "calendar-date",
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16749",
    "data-name": "Group 16749",
    transform: "translate(6 -0.334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M0,4.533A4.969,4.969,0,0,1,.218,2.425a2,2,0,0,1,.874-.874A4.969,4.969,0,0,1,3.2,1.333H8.8a4.969,4.969,0,0,1,2.108.218,2,2,0,0,1,.874.874A4.969,4.969,0,0,1,12,4.533v5.6a4.969,4.969,0,0,1-.218,2.108,2,2,0,0,1-.874.874,4.969,4.969,0,0,1-2.108.218H3.2a4.969,4.969,0,0,1-2.108-.218,2,2,0,0,1-.874-.874A4.969,4.969,0,0,1,0,10.133Z",
    transform: "translate(0 5.334)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon-2",
    "data-name": "Icon",
    d: "M12,5.333H0M8.667,0V2.667M3.333,0V2.667",
    transform: "translate(0 5.334)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDate);
export default __webpack_public_path__ + "static/media/calendar-date.918eb93ec594702486bbed675b7b36a3.svg";
export { ForwardRef as ReactComponent };